<template>
  <div class="partner-category-edit animatedBox">
    <div class="container fluid">
      <form @submit.prevent="submitForm">
        <div class="card pb-2">
          <h4 class="mainTitle lineBottom">Partner Category</h4>
          <div class="main-contents">
            <div class="input-wrapper required mt-2 px-0">
              <label>Title:</label>
              <input type="text" required v-model="category.title" />
            </div>
          </div>
        </div>

        <div class="btn-wrapper d-flex justify-content-end px-0 mxn-0 sm-mxn-1">
          <button type="submit" class="btn add mx-1">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "partner-category-edit",
  data() {
    return {
      category: {
        title: "",
      },
    };
  },
  mounted() {
    this.getPartnerCategory();
  },
  methods: {
    async getPartnerCategory() {
      const currentId = this.$route.path.split("/")[3];

      try {
        const request = await this.$store.dispatch(
          "partnerCategory/getPartnerCategory",
          {
            id: currentId,
          }
        );

        this.category = {
          title: request[0].name,
        };
      } catch (error) {
        alert("Error while loading data. Please try again later.");
        this.$router.push({ path: "/partner-category" });
        console.log(error);
        throw error;
      }
    },
    async submitForm() {
      const currentId = this.$route.path.split("/")[3];

      try {
        const request = await this.$store.dispatch(
          "partnerCategory/updatePartnerCategory",
          {
            id: currentId,
            data: {
              name: this.category.title,
            },
          }
        );

        alert("Partner category updated successfully.");
        this.$router.push({ path: "/partner-category" });
        return;
      } catch (error) {
        alert("An unexpected error occured. Please try again later.");
        console.log(error);
        throw error;
      }
    },
  },
};
</script>

<style lang="scss">
.partner-category-edit {
  form {
    @extend %formDesign;
  }
}
</style>